import { IconButton, InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState } from "react";
import PillTextField from "@/app/shared/PillTextField";
import SearchIcon from "@mui/icons-material/Search";
import PillButton from "@/app/shared/PillButton";

// AJB: need an apply button to close the menu?
export default function AspectText({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const [searchValue, setSearchValue] = useState(value);
  return (
    <PillTextField
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onChange(searchValue);
        }
      }}
      placeholder="Keyword"
      isSelected={!!searchValue}
      sx={{
        borderRadius: "100px",
        ".MuiInputBase-input": {
          flex: "stretch",
        },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {searchValue && (
                <>
                  {searchValue !== value ? (
                    <PillButton
                      primary
                      sx={{
                        height: "30px",
                        minWidth: "initial",
                        padding: 1,
                      }}
                      onClick={() => onChange(searchValue)}
                    >
                      Submit
                    </PillButton>
                  ) : (
                    <IconButton
                      size="small"
                      sx={{
                        color: "black",
                        backgroundColor: "grey.100",
                      }}
                    >
                      <ClearIcon
                        onClick={() => {
                          setSearchValue("");
                          onChange("");
                        }}
                      />
                    </IconButton>
                  )}
                </>
              )}
            </InputAdornment>
          ),
        },
      }}
      size="small"
    />
  );
}
